import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Tabs } from '@chapche/ui';
import useWindowDimensions from '../hooks/useWindowDimension';

const NavigationTabs = ({ navigationService }) => {
    const [activeRoute, setActiveRoute] = useState('');
    const [tabsList, setTabsList] = useState([]);
    const { tab, id } = useParams();
    const { width } = useWindowDimensions();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        setActiveRoute(location.pathname + location.search);
    }, [tab, id, location]);

    const changeActiveTabs = () => {
        setTabsList(navigationService.getTabs(activeRoute, id, width));
    };

    useEffect(() => {
        setTabsList(navigationService.getTabs(activeRoute, id, width));
        navigationService.registerTabsUpdateObserver(changeActiveTabs);
        return () => navigationService.unRegisterTabsUpdateObserver(changeActiveTabs);
    }, [activeRoute]);

    const activeIndex = Math.max(0, tabsList.findIndex((item) => item.isActive));
    const items = tabsList.map((item) => ({
        id: item.pageUrl,
        label: item.title,
    }));

    if (!items.length) {
        return null;
    }

    return (
        <Tabs
            items={items}
            activeIndex={activeIndex}
            size="large"
            onChange={(_index, item) => navigate(item.id, { replace: true })}
        />
    );
};

export default NavigationTabs;
